module.exports = __webpack_public_path__ + "img/tabs-bg-5.6ae0c663.png";